import React, {
  ForwardedRef,
  forwardRef,
  useEffect,
  useRef,
  useState,
} from 'react';
import { Marker, Polygon } from 'react-leaflet';
import type { Polygon as PolygoneType } from 'leaflet';
import L, { LatLngTuple } from 'leaflet';
import makeStyles from '@mui/styles/makeStyles';
import { dispatch_theme, white } from '../../../config/colors';
import { PostalCodeDump, Territory } from '../../../config/types/Territories';
import * as Leaflet from 'leaflet';

const useStyles = makeStyles((theme: typeof dispatch_theme) => ({
  marker: {
    display: 'block',
    color: white,
    fontWeight: 'bold',
    minWidth: 100,
    fontSize: '15px'
  },
}));

type Props = {
  area?: Territory;
  toggleZip: (area: Territory) => void;
  color: string;
  map: any;
  coordinates: LatLngTuple[];
  title: string;
  onContextMenu: (e: Leaflet.LeafletMouseEvent) => void;
  postal_code?: PostalCodeDump;
};

const TextPolygon = forwardRef((props: Props, ref: ForwardedRef<PolygoneType>) => {
  const {
    area,
    toggleZip,
    color,
    map,
    coordinates,
    title,
    onContextMenu,
    postal_code,
  } = props;
  const classes = useStyles();
  const [showText, setText] = useState(false);
  const center = L.polygon(coordinates).getBounds().getCenter();
  const _isMounted = useRef(true);

  const text =
    title &&
    L.divIcon({
      html: `${title}`,
      className: classes.marker,
    });

  useEffect(() => {
    if (map.getZoom() >= 10) {
      setText(true);
    }
    return () => {
      _isMounted.current = false;
    };
  }, []);

  map.on('zoom', () => {
    if (map.getZoom() >= 10 && !showText && _isMounted.current) {
      setText(true);
    }
    if (map.getZoom() < 10 && showText && _isMounted.current) {
      setText(false);
    }
  });

  const eventHandlers = {
    contextmenu: onContextMenu,
    click(){
      area ? toggleZip(area) : null;
    }
  };
  return (
    <Polygon
      ref={ref}
      className={`polygon-${postal_code?.id || 0}`}
      positions={coordinates}
      color={color || dispatch_theme.palette.secondary.main}
      fillColor={color || dispatch_theme.palette.secondary.main}
      fillOpacity={0.35}
      weight={2}
      eventHandlers={eventHandlers}
    >
      {showText && title && <Marker position={center} icon={text} />}
    </Polygon>

  );
});

TextPolygon.displayName = 'TextPolygon';

export default TextPolygon;
